import axios from 'axios';

/**
 * GET /api/search/?q=&limit= (the organization param is added by the axios interceptor in
 * index.js. `signal` lets the palette abort a request the user has already typed past.
 */
export async function searchGlobal(query, limit, signal) {
  const response = await axios.get('/api/search/', { params: { q: query, limit }, signal });
  return response.data;
}
